
import "./PremiumPlans.css";
import TopNavbar from "../../components/TopNavbar/TopNavbar";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";

import Premium_content_card from "../../components/premium_content_card/premium_content_card";

const PremiumPlans = () => {
  return (
    <>
      <TopNavbar />
      <Navbar />

      <h2 className="selectpackage_heading">Payment</h2>

      <Premium_content_card />

      <Footer />
    </>
  );
};

export default PremiumPlans;
